import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { useTranslation } from 'react-i18next';
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  const { t } = useTranslation();
  
  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          {t('footer.madeWith')} <span role="img">❤️</span> {t('footer.by')} {t('greeting.title')}
        </p>
        {/* <ToggleSwitch theme={props.theme} onToggle={props.onToggle}/> */}
      </Fade>
    </div>
  );
}
